module.exports = __webpack_public_path__ + "static/img/uranium-pellet_256.23df552.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/uranium-pellet_256.png
// module id = p537
// module chunks = 0